export default __webpack_public_path__ + "ddfc57892e4b0accfeee09e8317e4524.svg";